import * as React from 'react';
import * as _ from 'underscore';

import { ButtonType, ButtonWidget } from '@tableau/widgets';

import { Messages } from '../../../../codegen/Localize';
import { SpaceContainerStyles } from '../../../../style/SpaceContainerStyles';
import { ReactDirectiveProps } from '../../../../ts/directives/reactDirectiveFactory';
import { BrowserTitleService } from '../../../../commonInfra/services/BrowserTitleService';
import { appStore } from '../../../AppStore';
import { ConnectedExplorer } from '../../Explorer/ConnectedExplorer';
import { CreateSiteAction } from '../../Explorer/CreateContent/CreateContentActionsList';
import { SpaceHeaderWithTotalItemsCount } from '../../Header/SpaceHeaderWithTotalItemsCount';


export interface AllSitesSpaceStateProps {
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedSites: number;
}

export interface AllSitesSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
}

export type AllSitesSpaceProps = ReactDirectiveProps & AllSitesSpaceStateProps & AllSitesSpaceDispatchProps;

export class AllSitesSpace extends React.PureComponent<AllSitesSpaceProps> {
  public componentDidMount() {
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.sites() });
    this.props.requestSpaceContents();
  }

  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <SpaceHeaderWithTotalItemsCount
          onClick={this.onSpaceHeaderClick}
          label={Messages.sites()}
          testId={'sites'}
          count={this.props.numberOfFetchedSites}
          countUpToDate={!this.props.isBusyFetchingItems}
        />
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            angularContext={this.props.angularContext}
            supportedDisplayModes={['list']}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled',
              toolbarContentSpecificControls: { beginning: newSiteButton() }
            }}
            emptyStateProps={{
              primaryMessage: Messages.sitesEmptyMessage()
            }}
          />
        </div>
      </div>
    );
  }

  private onSpaceHeaderClick = () => {
    this.props.requestSpaceContents();
  }
}

export function newSiteButton(): JSX.Element {
  const appState = appStore.getState();
  const createSiteAction = CreateSiteAction;
  if (createSiteAction.isVisible(appState, 'sites') && createSiteAction.isClickable(appState)) {
    const reduxAction = createSiteAction.createReduxAction();
    const handleClick = () => appStore.dispatch(reduxAction);
    return (
      <ButtonWidget
        children={createSiteAction.title()}
        buttonType={ButtonType.Outline}
        handleClick={handleClick}
        tb-test-id={'action-create-new-site'}
        testId={'action-create-new-site'}/>
    );
  }
  return null;
}
